import { DAILY5_START_DATE } from '../config'
import getLocalDate from './getLocalDate'
import getPuzzleNumberForDate from './getPuzzleNumberForDate'

/**
 * Helper function to validate whether an archive puzzle should exist.
 * Currently only supports daily archive check, but can be easily expanded.
 */
export default function archivePuzzleExists(puzzleNumber: number) {
	// Sanity check
	if (isNaN(puzzleNumber)) return false

	// Daily puzzles start at 1
	if (puzzleNumber <= 0) return false

	const todaysDailyPuzzleNumber = getPuzzleNumberForDate(getLocalDate(), DAILY5_START_DATE, 1)

	// Today's puzzle is not yet in the Archive
	if (puzzleNumber === todaysDailyPuzzleNumber) return false

	// Future dates don't exist yet in the Arhive
	if (puzzleNumber > todaysDailyPuzzleNumber) return false

	// The puzzle should exist!
	return true
}
